import sanitize from 'sanitize-html';

// SanitizeHTML sanitizes user input HTML, stripping out malicious tags like
// <script> but still allowing things like font awesome icons and SVGs.
export const SanitizeHTML = (dirty) => sanitize(dirty, {
  allowedTags: ['b', 'i', 'em', 'strong', 'mark', 'span', 'div', 'br', 'svg',
    'path', 'small', 'big', 'sub', 'sup', 'pre', 'label'],
  allowedAttributes: {
    b: ['class'],
    div: ['class'],
    em: ['class'],
    i: ['class'],
    label: ['class'],
    path: ['fill', 'd'],
    span: ['class'],
    string: ['class'],
    svg: ['aria-hidden', 'data-fa-processed', 'data-prefix', 'data-icon',
      'role', 'xmlns', 'viewBox', 'class'],
  },
  allowedIframeHostnames: [],
  parser: {
    lowerCaseAttributeNames: false,
  },
});
